"use strict";

var _classCallCheck = require("/home/alfredo/Workspace/CarnesValidadas/Plataforma/v1/cv-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/alfredo/Workspace/CarnesValidadas/Plataforma/v1/cv-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionValidator = void 0;

var _findSuggestion = require("./find-suggestion");

var OptionValidator = /*#__PURE__*/function () {
  function OptionValidator(descriptor) {
    _classCallCheck(this, OptionValidator);

    this.descriptor = descriptor;
  }

  _createClass(OptionValidator, [{
    key: "validateTopLevelOptions",
    value: function validateTopLevelOptions(options, TopLevelOptionShape) {
      var validOptionNames = Object.keys(TopLevelOptionShape);

      for (var _i = 0, _Object$keys = Object.keys(options); _i < _Object$keys.length; _i++) {
        var option = _Object$keys[_i];

        if (!validOptionNames.includes(option)) {
          throw new Error(this.formatMessage("'".concat(option, "' is not a valid top-level option.\n- Did you mean '").concat((0, _findSuggestion.findSuggestion)(option, validOptionNames), "'?")));
        }
      }
    }
  }, {
    key: "validateBooleanOption",
    value: function validateBooleanOption(name, value, defaultValue) {
      if (value === undefined) {
        return defaultValue;
      } else {
        this.invariant(typeof value === "boolean", "'".concat(name, "' option must be a boolean."));
      }

      return value;
    }
  }, {
    key: "validateStringOption",
    value: function validateStringOption(name, value, defaultValue) {
      if (value === undefined) {
        return defaultValue;
      } else {
        this.invariant(typeof value === "string", "'".concat(name, "' option must be a string."));
      }

      return value;
    }
  }, {
    key: "invariant",
    value: function invariant(condition, message) {
      if (!condition) {
        throw new Error(this.formatMessage(message));
      }
    }
  }, {
    key: "formatMessage",
    value: function formatMessage(message) {
      return "".concat(this.descriptor, ": ").concat(message);
    }
  }]);

  return OptionValidator;
}();

exports.OptionValidator = OptionValidator;